// TODO - implement styled-system

// eslint-disable-next-line import/prefer-default-export
export const blockSizes = {
  sm: '28px',
  md: '36px',
  lg: '44px'
};
